<template>
<!-- 数字农业·农产品价格·二级页面 -->
  <div>
    <div id="farm" ref="farm">
      <div class="echarts_border">
        <div class="echart_zonglans">
          <ul class="flex">
            <li v-for="(item, index) in FarmList" :key="index" :class="activeClass == index? 'active':''" @click="IsActive(index,item)">
              {{ item }}
            </li>
          </ul>
        </div>
        <div id="echart_farm_one"></div>
        <p class="text-center">数据来源：{{Data_txt}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  components: {},
  props: {},
  data() {
    return {
      activeClass: 0,
      // 名称列表
      FarmList: [],
      // 数据
      oneMonth:[],
      oneThisYearNum:[],
      myChart:undefined,
      Data_txt:'',
      item_name: ''
    };
  },
  watch: {},
  computed: {},
  methods: {
     init_one() {
         // 获取农产品名称列表
      var nameList = plOtherDataInterface.getVegetableNameList();
      this.FarmList = nameList
      //初始化选择第一个
      var data_nong = plOtherDataInterface.getPriceThisYearLastYear(this.FarmList[0]);
      var monthArr = data_nong.map((item)=>item.theDate);
      var dayArr = data_nong.map((item)=>item.thePrice);
      this.oneMonth = monthArr;
      this.oneThisYearNum = dayArr;
       
      //
      this.myChart = echarts.init(document.getElementById("echart_farm_one"));
      var option = {
        tooltip: {
          trigger: "axis",
          formatter:(params)=>{
            return`
              <div style="font-size:12px;">${this.item_name}${params[0].data}元/斤</div>
            `
          }
        },
        legend: {},
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.oneMonth,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
            axisLabel:{
              show:true,
              textStyle: {
                color: "#fff",
              },
              interval: 0,    //强制文字产生间隔
            }
          },
        ],
        yAxis: [
          {
            name: "单位/(元/斤)",
            type: "value",
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
            axisLabel: {
              show: true, 
              textStyle: {
                color: "#fff",
              },
            },
            nameTextStyle: {
              color: "#fff",
            },
          },
        ],
        series: [
          {
            type: "line",
            smooth: false,
            yAxisIndex: 0,
            label: {
              show: true,
              position: "top",
               color: "#fff",
            },
            showSymbol: true,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#828F62",
                },
                {
                  offset: 1,
                  color: "#447569",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "#FADB7D",
              },
            },
            data: this.oneThisYearNum
          }
        ],
      };
      this.myChart.setOption(option);
    },
    IsActive(index,item){
      this.activeClass = index;
      // 获取农产品价格数据
      var data_nong = plOtherDataInterface.getPriceThisYearLastYear(item);
      var monthArr = data_nong.map((item)=>item.theDate);
      var dayArr = data_nong.map((item)=>item.thePrice);
      this.oneMonth = monthArr;
      this.oneThisYearNum = dayArr;
      var option = this.myChart.getOption();
      option.xAxis.data = this.oneMonth;
      option.series[0].data = this.oneThisYearNum;
      this.myChart.setOption(option);
      this.item_name = item
    },
      // 数据来源
    Sources(){
      var dataSources = this.$json;
      this.Data_txt = dataSources.data[4].price;
    },

  },
  created() {},
  mounted() {
    this.init_one();
    this.Sources();
  },
};
</script>
<style lang="less"  scoped>
#farm {
  background: #15606e;
}
.echarts_border{
  height: 39rem;
  overflow: auto;
}
.echart_zonglans {
  margin: 1.875rem 0 0 0;
  border-top: 1px solid rgb(121, 226, 154);
  padding-top: 1.875rem;
}
#echart_farm_one {
  height: 18.75rem;
  margin-top: 20px;
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
.flex {
  display: flex;
  justify-content: space-around;
  padding: 0;
  margin: 0;
  li {
    list-style: none;
    padding: 0 15px;
    box-sizing: border-box;
    height: 27px;
    border-radius: 5px;
    background: #39819a;
    color: #ebfaff;
    font-size: 16px;
    text-align: center;
    line-height: 27px;
    cursor: pointer;
  }
}
 .active{
    background: #0A4960 !important;
    border: 1px solid #3ef89c;
    border-radius: 5px;
    line-height: 27px;
  }
::-webkit-scrollbar {
  background-color: #15606e;
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #00574A;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */
</style>


// WEBPACK FOOTER //
// src/components/leftAside/detail_farming/Farm_Products.vue